import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { map, switchMap, take } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import { DialogService } from '@core/user-interface-legacy';
import { AskTicketsActions } from '@tellent-ask-hr/tickets-data';

import { TicketsDataService } from './tickets-data.service';

@Injectable({ providedIn: 'root' })
export class TicketService {
  private readonly dialogService = inject(DialogService);
  private readonly ticketsDataService = inject(TicketsDataService);
  private readonly i18n = inject(I18nService);
  private readonly actions$ = inject(Actions);

  public confirmCancel(ticketId: number) {
    return this.dialogService
      .error({
        title: this.i18n.translate('tlc.ask_hr.request_dialog.cancel_request'),
        message: this.i18n.translate('tlc.ask_hr.request_dialog.cancel_request_description'),
        agreeLabel: this.i18n.translate('tlc.ask_hr.request_dialog.confirm_cancel'),
      })
      .pipe(
        take(1),
        filterBoolean,
        switchMap(isSuccess =>
          isSuccess
            ? this.ticketsDataService.cancelTicket(ticketId).pipe(map(result => result.isSuccess))
            : [false],
        ),
      );
  }

  public getViewsRefreshEvents$() {
    return this.actions$.pipe(
      ofType(
        AskTicketsActions.createOnePessimisticSuccess,
        AskTicketsActions.updateOnePessimisticSuccess,
        AskTicketsActions.moveSuccess,
        AskTicketsActions.cancelSuccess,
      ),
      map(() => void 0),
    );
  }
}
